module.exports = __webpack_public_path__ + "static/img/role.d4bcddb.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/img/role3/mx/role.png
// module id = nC/Y
// module chunks = 7